import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";
import { Component, Inject, Mixins } from "vue-property-decorator";
import VEmptyState from "@/vuetify-extensions/VEmptyState.vue";
import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import ReferralsClient from "../../services/ReferralsClient";
import { EServices } from "@/types";
import VScrollView from "@/vuetify-extensions/VScrollView.vue";

@Component({
  components: {
    VEmptyState,
    VScrollView,
  },
})
export default class Leaderboard extends Mixins(JackocoinsNetworkManagerMixin) {
  title: string = "Leaderboard";
  refresh = false;
  leaders = [];
  headers = [
    { text: "Ranking", value: "ranking" },
    { text: "Username", value: "username" },
    { text: "Points Earned", value: "points" },
  ];

  @Inject(EServices.referrals)
  referralClient!: ReferralsClient;

  currentDate = new Date();
  startDate = this.getPreviousSunday();
  stopDate = this.getPreviousSaturday();

  getPreviousSunday() {
    let date = new Date();
    let day = date.getDay(); // Get current day of the week (0-6, where 0 is Sunday)
    let diff = date.getDate() - day; // Calculate the difference in days to get to Sunday
    let sundayDate = new Date(date.setDate(diff)); // Set date to the previous Sunday
    return sundayDate.toISOString().substr(0, 10);
  }

  getPreviousSaturday() {
    let date = new Date();
    let day = date.getDay(); // Get current day of the week (0-6, where 0 is Sunday)
    let diff = 6 - day; // Calculate the difference in days to get to Saturday
    let saturdayDate = new Date(date.setDate(date.getDate() + diff)); // Set date to the previous Saturday
    return saturdayDate.toISOString().substr(0, 10);
  }

  get leadersBoard() {
    return this.leaders;
  }

  maskString(str: string, visibleLength = 4) {
    const visiblePart = str.substring(0, visibleLength);
    const maskedPart = "*".repeat(str.length - visibleLength);
    return visiblePart + maskedPart;
  }

  @throwsNetworkError()
  async fetchLeaderboard() {
    const startDate = this.startDate;
    const endDate = this.stopDate;
    const response = await this.referralClient.fetchLeaderboard({
      page: 1,
      size: 20,
      startDate,
      endDate,
    });

    this.leaders = response.data;
    return response;
  }

  mounted() {
    this.fetchLeaderboard();
  }
}
